/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssignmentLetter } from './assignment-letter';
import { EmployeesEmployeeSnapshot } from './employees-employee-snapshot';
import { MemberLight } from './member-light';
import { RecordLetterStateModel } from './record-letter-state-model';
import { PlanLight } from './plan-light';
import { SeasonLight } from './season-light';
import { RecordCommentModel } from './record-comment-model';

export interface MonitoringRecord {
  id?: string;
  assignmentId?: string | null;
  reassignmentId?: string | null;
  memberId?: string | null;
  creationContext?: MonitoringRecordCreationContextEnum;
  state?: MonitoringRecordStateEnum;
  startDate?: string;
  endDate?: string;
  member?: MemberLight;
  plan?: PlanLight;
  season?: SeasonLight;
  letters?: Array<AssignmentLetter> | null;
  initialSnapshot?: EmployeesEmployeeSnapshot;
  durationInCalenderDays?: number;
  proration?: number;
  proratedTiaLocalCurrency?: number;
  proratedTiaEuro?: number;
  ippAchievementValue?: number;
  payoutAmount?: number;
  payoutAmountInEuro?: number;
  totalTargetAchievement?: number;
  unitTargetAchievement?: number;
  unitTargetPayoutAmount?: number;
  unitTargetPayoutAmountInEuro?: number;
  individualMultiplierValue?: number;
  comments?: Array<RecordCommentModel> | null;
  payoutState?: MonitoringRecordPayoutStateEnum | null;
  payoutDate?: string;
  exportState?: MonitoringRecordExportStateEnum;
  definedPayoutPercentage?: number | null;
  recordLetterStates?: Array<RecordLetterStateModel> | null;
  processState?: MonitoringRecordProcessStateEnum;
}
export enum MonitoringRecordCreationContextEnum {
  IncentiveProcess = 'IncentiveProcess',
  Reassignment = 'Reassignment',
  Manual = 'Manual',
  SogProcess = 'SogProcess',
  LetterAndPayroll = 'LetterAndPayroll',
  Other = 'Other'
}
export enum MonitoringRecordStateEnum {
  Active = 'Active',
  Draft = 'Draft',
  Outdated = 'Outdated',
  Irrelevant = 'Irrelevant'
}
export enum MonitoringRecordPayoutStateEnum {
  StandardPayout = 'StandardPayout',
  FullPayout = 'FullPayout',
  DefinedPayoutEndOfFiscalYear = 'DefinedPayoutEndOfFiscalYear',
  NoPayout = 'NoPayout',
  Irrelevant = 'Irrelevant'
}
export enum MonitoringRecordExportStateEnum {
  Open = 'Open',
  Done = 'Done'
}
export enum MonitoringRecordProcessStateEnum {
  None = 'None',
  Open = 'Open',
  TafCreated = 'TafCreated',
  TafPublished = 'TafPublished',
  ReadyForCalculation = 'ReadyForCalculation',
  Calculated = 'Calculated',
  Frozen = 'Frozen',
  AchievementLetterCreated = 'AchievementLetterCreated',
  AchievementLetterPublished = 'AchievementLetterPublished'
}
